import { render, staticRenderFns } from "./LayoutGutters.vue?vue&type=template&id=6dd07d0d"
import script from "./LayoutGutters.vue?vue&type=script&lang=js"
export * from "./LayoutGutters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports